import React from 'react';
import { func_datetime, func_validation, isStringTrimNotEmpty } from 'functions';
import { Tooltip } from 'components/informational/Tooltip';

export function useTableColumns() {
    
    function getColumn_sourceNum() {
        let columnClassName = "columns__sourceNum";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Document No",
            id: "sourceNum",
            accessor: "sourceNumber",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_planNum() {
        let columnClassName = "columns__planNum";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Plan No",
            id: "planNum",
            accessor: "revenuePlanID",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_appliedOutlet() {
        let columnClassName = "columns__appliedOutlet";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Applied Outlet",
            id: "appliedOutlet",
            accessor: "referenceKeyInfo",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let isSubrow = func_validation.isTableRowIndexSubrow(props);
                let selectedOutlets = func_validation.getObjectPropertyValue(props, "value");
                let appliedOutlet = func_validation.getArrayLength(selectedOutlets, 0);
                let outletListDisplay = []
                
                if (func_validation.isArrayNotEmpty(selectedOutlets)) {
                    outletListDisplay = selectedOutlets.map((outletObj, idx) => {
                        return (<div key={idx}>{outletObj?.chargeValue}</div>);
                    })
                }

                return isSubrow? (
                    <div className={"columns__appliedOutlet-cell-subrow"}>
                        {outletListDisplay}
                    </div>
                ):(
                    <div className={"noWrap-text-ellipsis"}>{appliedOutlet} Outlet(s)</div>
                );
            },
            width: 200
        }
    }

    function getColumn_comId() {
        let columnClassName = "columns__comId";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Company ID",
            id: "comId",
            accessor: "customerData",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isObjectNotEmpty(value)? value?.comId: "";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_accountCode() {
        let columnClassName = "columns__accountCode";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Account Code",
            id: "accountCode",
            accessor: "customerData",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isObjectNotEmpty(value)? value?.accountCode: "";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_productCode() {
        let columnClassName = "columns__productCode";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Product Code",
            id: "productCode",
            accessor: "itemData",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isObjectNotEmpty(value)? value?.itemCode: "";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    return [
        getColumn_sourceNum(),
        getColumn_planNum(),
        getColumn_appliedOutlet(),
        getColumn_comId(),
        getColumn_accountCode(),
        getColumn_productCode()
    ]
}